import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";


export class OmsBulkDispatchPanelController implements IController {
  firstMileActive: boolean;
  middleMileActive: boolean;
  lastMileActive: boolean;
  onChange: Function;

  public notBeforeToday: any;
  public isFirstMileSelected: boolean = false;
  public isMiddleMileSelected: boolean = false;
  public isLastMileSelected: boolean = false;
  public range: any;
  public milesData: any = {};
  public branchIds: string [] = [];

  type: any = [
    {
      key: 'Per Service',
      value: 'perService'
    },
    {
      key: 'Per Task',
      value: 'perTask'
    }
  ]

  constructor(private moment) {
  }

  $onInit() {
    this.notBeforeToday = this.moment().startOf('day').valueOf();
    this.milesData = {
      firstMile: {
        active: false,
        isPerServiceOrTask: 'perService',
        originDate: this.moment().startOf('day').valueOf(),
        originStartTime: this.moment().startOf('hour').valueOf(),
        originEndTime: this.moment().startOf('hour').valueOf(),
        deliveryDate: this.moment().startOf('day').valueOf(),
        deliveryStartTime: this.moment().startOf('hour').valueOf(),
        deliveryEndTime: this.moment().startOf('hour').valueOf()
      },
      middleMile: {
        active: false,
        isPerServiceOrTask: 'perService',
        originDate: this.moment().startOf('day').valueOf(),
        originStartTime: this.moment().startOf('hour').valueOf(),
        originEndTime: this.moment().startOf('hour').valueOf(),
        deliveryDate: this.moment().startOf('day').valueOf(),
        deliveryStartTime: this.moment().startOf('hour').valueOf(),
        deliveryEndTime: this.moment().startOf('hour').valueOf()
      },
      lastMile: {
        active: false,
        isPerServiceOrTask: 'perService',
        originDate: this.moment().startOf('day').valueOf(),
        originStartTime: this.moment().startOf('hour').valueOf(),
        originEndTime: this.moment().startOf('hour').valueOf(),
        deliveryDate: this.moment().startOf('day').valueOf(),
        deliveryStartTime: this.moment().startOf('hour').valueOf(),
        deliveryEndTime: this.moment().startOf('hour').valueOf()
      }
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.firstMileActive && changes.firstMileActive.currentValue !== changes.firstMileActive.previousValue && this.firstMileActive && !changes.firstMileActive.isFirstChange()) {
      this.isFirstMileSelected = true;
    }
    if (changes.middleMileActive && changes.middleMileActive.currentValue !== changes.middleMileActive.previousValue && this.middleMileActive && !changes.middleMileActive.isFirstChange()) {
      this.isMiddleMileSelected = true;
    }
    if (changes.lastMileActive && changes.lastMileActive.currentValue !== changes.lastMileActive.previousValue && this.lastMileActive && !changes.lastMileActive.isFirstChange()) {
      this.isLastMileSelected = true;
    }
  }

  onTimeChange(obj, ref, time) {
    obj[ref] = time;
    if (ref === 'originStartTime' && (obj.originEndTime <= time)) {
      obj.originEndTime = this.moment(time).valueOf()
    } else if (ref === 'deliveryStartTime' && (obj.deliveryEndTime <= time)) {
      obj.deliveryEndTime = this.moment(time).valueOf()
    }
    if (ref === 'originStartTime' && (obj.deliveryStartTime <= time)) {
      obj.deliveryStartTime = this.moment(time).valueOf();
      obj.deliveryEndTime = this.moment(time).valueOf()
    }
    this.onChange({milesData: this.milesData});
  }

  onDateChange(obj, ref, isOrigin, date) {
    obj[ref] = date;
    if (isOrigin) {
      obj.originStartTime = this.moment(obj.originStartTime).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date()
      }).valueOf();
      obj.originEndTime = this.moment(obj.originEndTime).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date()
      }).valueOf();
      if (obj.originStartTime > obj.deliveryStartTime) {
        obj.deliveryStartTime = angular.copy(obj.originStartTime);
      }
    } else {
      obj.deliveryStartTime = this.moment(obj.deliveryStartTime).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date()
      }).valueOf();
      obj.deliveryEndTime = this.moment(obj.deliveryEndTime).set({
        year: this.moment(date).year(),
        month: this.moment(date).month(),
        date: this.moment(date).date()
      }).valueOf();
      if (obj.deliveryStartTime < obj.originStartTime) {
        obj.originStartTime = angular.copy(obj.deliveryStartTime);
      }
    }
    this.onChange({milesData: this.milesData});
  }

  onBranchesChange(branchIds) {
    this.branchIds = branchIds;
    this.milesData.manualBranchIds = branchIds;
    this.onChange({milesData: this.milesData});
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsBulkDispatchPanel', {
    bindings: {
      milesData: '<',
      firstMileActive: '<?',
      middleMileActive: '<?',
      lastMileActive: '<?',
      onChange: '&'
    },
    template: require('./oms-bulk-dispatch-panel.html').default,
    controller: OmsBulkDispatchPanelController
  });
